import React, { useState, useEffect, useCallback } from "react";
import "./index.css";
import { useCustomHook } from "../../InternalTransactionMain/InternalTransactionCreate/useCustomHook";
import { useDispatch, useSelector } from "react-redux";
import SelectServiceProvider from "../../../components/Settings/BYOK/SelectServiceProvider";
import { useNavigate } from "react-router-dom";
import SelectKeyId from "../../../components/Settings/BYOK/SelectKeyId";
import {
  fetchCloudKeys,
  resetFetchKeys,
  cloudKeyList,
  fetchNewCloudKeys,
  resetNewFetchKeys,
  uploadCloudKeys,
} from "../../../redux/features/byok/byok";
import { toast } from "react-toastify";
import ByokDashboard from "../../../components/Settings/BYOK/BYOKconfirmation";
import { debounce } from "lodash";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import TEXT from "../../../utils/globalText";
import SvgComponent from "../../../components/_utils/SVGComponent";
import ICONS from "../../../assets/Icons";
import CommonToast from "../../../components/_utils/CommonToast";

const ByokCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [isMounted, setIsMounted] = useState(true);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [direction, setDirection] = useState("next");
  const [nextButtonEnabled, BenEnableNextButton] = useState(false);
  const [currentDisplay, setCurrentDisplay] = useState("ByokDashboardPage");
  const [providerOpen, setProviderOpen] = useState(false);
  const [serviceSelected, setServiceSelected] = useState("");
  const [bankingSelected, setBankingSelected] = useState(false);
  const [selectKey, setSelectKey] = useState("");
  const [credsExists, setCredsExists] = useState(false);
  const [updateCreds, setUpdateCreds] = useState(false);
  const accessKeyRegex = /^(AKIA|ASIA)[0-9A-Z]{16}$/;
  const secretAccessKeyRegex = /^[A-Za-z0-9/+=]{40}$/;
  const sessionTokenRegex = /^[A-Za-z0-9/+=]{200,2000}$/;
  const [canEncrypt, setCanEncrypt] = useState(false);
  const [currentFetchedKey, setCurrentFetchedKey] = useState("");
  const [rotatingKey, setRotatingKey] = useState("");
  const [updatedKeyDone, setUpdatedKeyDone] = useState(false);
  const [isChangeKeyFlowStarted, setIsChangeKeyFlowStarted] = useState(false);
  const [isChangeKeyFlowComplted, setIsChangeKeyFlowComplted] = useState(false);
  const [isEncryptDone, setIsEncryptDone] = useState(false);
  const [isRotatingKeys, setisRotatingKeys] = useState(false);
  const regions = [
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
    "ca-central-1",
    "sa-east-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-south-2",
    "eu-central-2",
    "ap-south-1",
    "ap-south-2",
    "ap-southeast-1",
    "ap-southeast-2",
    "ap-southeast-3",
    "ap-southeast-4",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-northeast-3",
    "ap-east-1",
    "me-central-1",
    "me-south-1",
    "af-south-1",
  ];
  const [openEncryptConfPopup, setOpenEncryptConfPopup] = useState(false);
  const [credentials, setCredentials] = useState({
    region: "",
    access_key: "",
    secret_access_key: "",
    session_token: "",
    platform: "aws",
  });
  const [credentialsFocus, setCredentialsFocus] = useState({
    region: false,
    access_key: false,
    secret_access_key: false,
    session_token: false,
  });

  const [isBYOKEncProcessing, setIsBYOKEncProcessing] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [isUpdateKey, setIsUpdateKey] = useState(false);

  const {
    fetchCloudKeysLoading,
    fetchCloudKeysData,
    fetchCloudKeysError,
    cloudKeyListLoading,
    cloudKeyListData,
    cloudKeyListError,
    cloudKeyListErrorMsg,
    fetchNewCloudKeysData,
    fetchNewCloudKeysError,
    encryptCloudKeysLoading,
    rotateKeysGetLoading,
  } = useSelector((state) => state.byok);

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;

    if (navType === "reload") {
      if (currentDisplay === "BYOKstepperPage") {
        setActiveStep(0);
      }
      // Update or reset state here
    } else {
    }
  }, []);
  const handleServiceProvider = (e) => {
    dispatch(resetFetchKeys());
    dispatch(resetNewFetchKeys());
    setCredsExists(false);
    setBankingSelected(false);
    setSelectKey("");
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (cloudKeyListErrorMsg === "Credentials Not Found") {
      setUpdateCreds(false);
    } else {
      setUpdateCreds(true);
    }
  }, [cloudKeyListData, cloudKeyListError]);

  const steps = isUpdateKey
    ? ["Select service provider and enter credentials"]
    : [
        "Select service provider and enter credentials",
        "Select key ID and encrypt data",
      ];

  const { shouldRender, animationClass } = useCustomHook(
    isMounted,
    270,
    direction,
  );

  const toggleMounting = () => {
    setIsMounted(false);
    setTimeout(() => {
      setIsMounted(true);
    }, 270);
  };
  const allFilled = Object.values(credentials).every(
    (value) => value.trim() !== "",
  );

  const handleNextLogic = async () => {
    const keysAlreadyFetched =
      fetchCloudKeysData?.status === true ||
      credsExists ||
      fetchNewCloudKeysData?.status === true;

    // Case 1: Updating credentials on Step 0
    if (isUpdateKey && activeStep === 0) {
      const response = await dispatch(uploadCloudKeys(credentials));

      if (response?.payload?.message === "Credentials Updated successfully.") {
        const response = await dispatch(cloudKeyList({ showToast: true }));
        if (response?.payload?.encryption_key) {
          setUpdatedKeyDone(true);
          setCurrentDisplay("ByokDashboardPage");
        }
      }

      return;
    }

    // Case 2: Step 0 - Regular key fetch
    if (activeStep === 0) {
      if (keysAlreadyFetched) {
        const response = await dispatch(cloudKeyList({ showToast: false }));

        const keysFound =
          response?.payload?.message === "Keys retrieved successfully." &&
          Array.isArray(response.payload?.keys) &&
          response.payload.keys.length > 0;

        if (keysFound || credsExists) {
          proceedToNextStep();
        }
      } else {
        try {
          // this is change key flow

          if (updateCreds) {
            await dispatch(fetchNewCloudKeys(credentials)).unwrap();
          } else {
            await dispatch(fetchCloudKeys(credentials)).unwrap();
          }
          await dispatch(cloudKeyList({ showToast: false }));

          setIsChangeKeyFlowStarted(true);
          toast.dismiss();
          CommonToast({
            text: "Keys fetched successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });

          proceedToNextStep();
        } catch (error) {
          BenEnableNextButton(false);
        }
      }
    }

    // Case 3: Step 1 - Show encryption confirmation popup
    if (activeStep === 1) {
      setOpenEncryptConfPopup(true);
    }
  };

  const proceedToNextStep = () => {
    setActiveStep((prev) => prev + 1);
    setDirection("next");
    toggleMounting();
    setRemoveClassName(false);
    setTimeout(() => setRemoveClassName(true), 1000);
  };

  // Debounce it with 500ms delay
  const handleNext = useCallback(debounce(handleNextLogic, 500), [
    activeStep,
    credsExists,
    credentials,
    updateCreds,
  ]);

  const handleBack = () => {
    if (activeStep === 0) {
      setServiceSelected(false);
      setProviderOpen(false);
      setBankingSelected(false);
      setSelectKey("");
      dispatch(resetFetchKeys());
      dispatch(resetNewFetchKeys());
      setCurrentDisplay("ByokDashboardPage");
      setisRotatingKeys(false);
      setCredentials({
        region: "",
        access_key: "",
        secret_access_key: "",
        session_token: "",
        platform: "aws",
      });
      setCredentialsFocus({
        region: false,
        access_key: false,
        secret_access_key: false,
        session_token: false,
      });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setDirection("previous");
      toggleMounting();
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
    }
  };

  const renderByok = () => {
    switch (activeStep) {
      case 0:
        return (
          <SelectServiceProvider
            providerOpen={providerOpen}
            setProviderOpen={setProviderOpen}
            serviceSelected={serviceSelected}
            setServiceSelected={setServiceSelected}
            credentials={credentials}
            setCredentials={setCredentials}
            credentialsFocus={credentialsFocus}
            setCredentialsFocus={setCredentialsFocus}
            handleServiceProvider={handleServiceProvider}
            fetchCloudKeysLoading={fetchCloudKeysLoading}
            fetchCloudKeysData={fetchCloudKeysData}
            fetchCloudKeysError={fetchCloudKeysError}
            setBankingSelected={setBankingSelected}
            setSelectKey={setSelectKey}
            credsExists={credsExists}
            accessKeyRegex={accessKeyRegex}
            secretAccessKeyRegex={secretAccessKeyRegex}
            sessionTokenRegex={sessionTokenRegex}
            regions={regions}
            fetchNewCloudKeysError={fetchNewCloudKeysError}
            setisRotatingKeys={setisRotatingKeys}
            isRotatingKeys={isRotatingKeys}
            isUpdateKey={isUpdateKey}
          />
        );
      case 1:
        return (
          <SelectKeyId
            selectKey={selectKey}
            setSelectKey={setSelectKey}
            cloudKeyListLoading={cloudKeyListLoading}
            cloudKeyListData={cloudKeyListData}
            cloudKeyListError={cloudKeyListError}
            bankingSelected={bankingSelected}
            setBankingSelected={setBankingSelected}
            openEncryptConfPopup={openEncryptConfPopup}
            setOpenEncryptConfPopup={setOpenEncryptConfPopup}
            setCurrentDisplay={setCurrentDisplay}
            setCanEncrypt={setCanEncrypt}
            setIsBYOKEncProcessing={setIsBYOKEncProcessing}
            encryptCloudKeysLoading={encryptCloudKeysLoading}
            showMsg={showMsg}
            setShowMsg={setShowMsg}
            isRotatingKeys={isRotatingKeys}
            setisRotatingKeys={setisRotatingKeys}
            currentFetchedKey={currentFetchedKey}
            setCurrentFetchedKey={setCurrentFetchedKey}
            rotateKeysGetLoading={rotateKeysGetLoading}
            isChangeKeyFlowStarted={isChangeKeyFlowStarted}
            isChangeKeyFlowComplted={isChangeKeyFlowComplted}
            setIsChangeKeyFlowComplted={setIsChangeKeyFlowComplted}
            setIsEncryptDone={setIsEncryptDone}
          />
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (activeStep === 0 && allFilled) {
      if (
        accessKeyRegex.test(credentials.access_key) &&
        secretAccessKeyRegex.test(credentials.secret_access_key) &&
        regions.includes(credentials.region) &&
        sessionTokenRegex.test(credentials.session_token)
      ) {
        BenEnableNextButton(true);
      } else {
        BenEnableNextButton(false);
      }
    } else if (activeStep === 1 && selectKey?.length !== 0 && bankingSelected) {
      if (isRotatingKeys && selectKey === rotatingKey) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    } else {
      BenEnableNextButton(false);
    }
  }, [activeStep, allFilled, selectKey, bankingSelected, credentials]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Fetch keys",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: "Select service provider and enter credentials",
    },
    {
      previousText: "Previous",
      nextText: "Encrypt",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "white",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: "Select key ID and encrypt data",
    },
  ];

  const updateDataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "white",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: "Select service provider and enter credentials",
    },
  ];

  return (
    <div className="w-width-full flex justify-start items-center flex-col bg-primary-bg h-screen">
      {/* Mobile header  */}
      <div className=" bg-custom-card Qsmd:hidden flex items-center fixed top-top-base w-full z-z-index-header shadow-box-shadow-bottom">
        <div
          className="p-padding-md cursor-pointer"
          onClick={() => {
            if (currentDisplay === "ByokDashboardPage") {
              navigate(-1);
            } else if (activeStep === 1) {
              setActiveStep(1);
            } else if (activeStep === 0) {
              setCurrentDisplay("ByokDashboardPage");
            }
          }}
        >
          <SvgComponent
            url={
              "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
            }
            height={"var(--icon-sm)"}
            width={"var(--icon-sm)"}
            color={"var(--text-primary)"}
          />
        </div>
        <div className="text-text-primary font-normal text-font-md">
          {TEXT?.BYOK_ENCRYPTION}
        </div>
      </div>
      {/* Mobile header  */}

      {/* <div className="Qmd:pt-[var(--navbar-breadcrumb-height)] pt-[var(--mobile-navbar-height)] w-full min-h-screen bg-primary-bg"></div>
       */}

      {/* Main container  */}
      <div className="byokMainontainer w-full">
        <div
          className={`Qsmd:h-navbar-breadcrumb-height h-mobile-navbar-height ${currentDisplay === "ByokDashboardPage" ? "bg-primary-nav" : ""} `}
        ></div>
        {currentDisplay === "ByokDashboardPage" && (
          <>
            <ByokDashboard
              setCurrentDisplay={setCurrentDisplay}
              setServiceSelected={setServiceSelected}
              setProviderOpen={setProviderOpen}
              setCredentialsFocus={setCredentialsFocus}
              setCredentials={setCredentials}
              setCredsExists={setCredsExists}
              setActiveStep={setActiveStep}
              canEncrypt={canEncrypt}
              setCanEncrypt={setCanEncrypt}
              isBYOKEncProcessing={isBYOKEncProcessing}
              setIsBYOKEncProcessing={setIsBYOKEncProcessing}
              setBankingSelected={setBankingSelected}
              setSelectKey={setSelectKey}
              isRotatingKeys={isRotatingKeys}
              setisRotatingKeys={setisRotatingKeys}
              currentFetchedKey={currentFetchedKey}
              setCurrentFetchedKey={setCurrentFetchedKey}
              setRotatingKey={setRotatingKey}
              encryptedKey={cloudKeyListData?.encryption_key}
              setIsUpdateKey={setIsUpdateKey}
              isUpdateKey={isUpdateKey}
              updatedKeyDone={updatedKeyDone}
              setUpdatedKeyDone={setUpdatedKeyDone}
              isChangeKeyFlowComplted={isChangeKeyFlowComplted}
              isEncryptDone={isEncryptDone}
            />
          </>
        )}
        {currentDisplay === "BYOKstepperPage" && (
          <>
            {/* Stepper */}
            <div className="fixed Qsmd:top-top-base top-auto Qsmd:bottom-auto bottom-bottom-base  w-full  pt-padding-base z-z-index-header Qsmd:relative min-h-stepper-height">
              <div className="Qlg:w-max-content-width w-full mx-auto">
                <PrimaryStepper
                  activeStep={activeStep}
                  handleForwardAction={handleNext}
                  handleBackwardAction={handleBack}
                  dataArray={isUpdateKey ? updateDataArray : dataArray}
                />
              </div>
            </div>
            {/* Stepper  */}
            {/* <div className="w-full pb-[var(--min-height-secondary-edge-fill-btn)] Qmd:pb-padding-md relative z-z-index-content bg-primary-bg Qmd:pt-[calc(var(--navbar-breadcrumb-height)+var(--min-height-secondary-edge-fill-btn))] pt-[var(--min-height-secondary-edge-fill-btn)]">
                <div className="Qlg:w-max-content-width w-full mx-auto flex justify-between relative pt-padding-md bg-primary-bg">
                  {shouldRender && (
                    <div
                      className={`w-full px-padding-md pb-padding-md ${
                        activeStep === 0 && direction === "next"
                          ? ""
                          : removeClassName === true
                            ? ""
                            : animationClass
                      }`}
                    >
                      {renderByok()}
                    </div>
                  )}
                </div>
              </div> */}

            <div className="pt-padding-base w-full h-full-height pb-medium-screen-top-padding">
              <div className="Qlg:w-max-content-width w-full mx-auto">
                {shouldRender && (
                  <div
                    className={`w-full px-padding-md pb-padding-md ${
                      activeStep === 0 && direction === "next"
                        ? ""
                        : removeClassName === true
                          ? ""
                          : animationClass
                    }`}
                  >
                    {renderByok()}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Main container  */}
    </div>
  );
};

export default ByokCreate;
